module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/pc/svg/toolbar_transparency-42d09f.svg";